<script setup lang="ts">
import { Sparkles } from 'lucide-vue-next'

interface Props {
  disabled?: boolean
  loading?: boolean
  active?: boolean
  title?: string
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  loading: false,
  active: false,
  title: '',
})
</script>

<template>
  <button
    type="button"
    :disabled="disabled || loading"
    :title="title"
    :aria-label="title || undefined"
    class="inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border-0 bg-transparent p-0.5 text-[var(--p-primary-color)] transition disabled:cursor-not-allowed disabled:opacity-50 hover:bg-[var(--p-primary-50)]! dark:hover:bg-[var(--p-primary-900)]/30!"
    :class="
      active
        ? 'bg-[var(--p-surface-100)] dark:bg-[var(--p-surface-800)] dark:text-[var(--p-primary-50)]'
        : ''
    "
  >
    <Sparkles class="h-4 w-4 dark:text-[var(--p-primary-50)]" :class="[loading ? 'animate-pulse' : '']" :stroke-width="2" />
  </button>
</template>
